import { apiClient } from './api'

export interface TranscriptionResult {
  transcription: string
  extracted: {
    motif: string
    gravite: string
    besoins: string[]
    contexte: string
  } | null
  locale: string
  durationMs: number
}

export const voiceAPI = {
  transcribe: async (audioFile: Blob, locale = 'fr'): Promise<TranscriptionResult> => {
    const formData = new FormData()
    formData.append('file', audioFile, 'recording.webm')
    formData.append('locale', locale)

    const res = await apiClient.post<TranscriptionResult>('/api/v1/voice/transcribe', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30000,
    })
    return res.data
  },
}
